import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetChallengeRateLimitV2Response } from './get-challenge-rate-limit-v2-response';
import { getChallengeRateLimitV2ResponseSchema } from './get-challenge-rate-limit-v2-response';

export async function getChallengeRateLimitV2Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetChallengeRateLimitV2Response>> {
  return getRequest<IGetChallengeRateLimitV2Response>({
    path: '/reviews/v2/rate-limit',
    schema: getChallengeRateLimitV2ResponseSchema,
    options,
  });
}
